import { User } from 'domain/User';
import { alert } from 'store/alert';
import { AddAlertAction } from 'store/alert/types';
import { ThunkCommandFactory } from '../types';
import * as actions from './actions';
import {
  SetUserListLoadingAction, AddUserAction, RemoveUserAction, UpdateUserAction,
  RefreshUserListAction,
} from './types';

export const addUser:
ThunkCommandFactory<User, AddAlertAction | AddUserAction> = (user) => (dispatch, state, client) => {
  const { tenantId } = user;
  return client.post<User>(`/${tenantId}/user/register`, user).then((newUser) => {
    if (!newUser) {
      dispatch(alert.showErrorMessage('addContractError'));
      return;
    }
    dispatch(alert.showSuccessMessage(
      'addUser',
      { email: newUser.email, password: newUser.password, role: newUser.role },
    ));
    dispatch(actions.addUser(newUser));
  });
};

export const updateUser:
ThunkCommandFactory<User, AddAlertAction |UpdateUserAction> = (user) => (dispatch, state, client) => {
  const { tenantId } = user;
  return client.post<User>(`/${tenantId}/user/${user.id}`, user).then((updatedUser) => {
    if (!updatedUser) {
      dispatch(alert.showErrorMessage('addContractError'));
      return;
    }
    dispatch(alert.showSuccessMessage('updateUser', { id: user.id }));
    dispatch(actions.updateUser(updatedUser));
  });
};

export const removeUser:
ThunkCommandFactory<User, AddAlertAction | RemoveUserAction> = (user) => (dispatch, state, client) => {
  const { tenantId } = user;
  const userId = user.id;
  return client.delete<boolean>(`/${tenantId}/user/${userId}`).then((isSuccess) => {
    if (isSuccess) {
      dispatch(alert.showSuccessMessage('removeUser', { email: user.email }));
      dispatch(actions.removeUser(user));
    } else {
      dispatch(alert.showErrorMessage('removeUserError', { email: user.email }));
    }
  });
};

export const refreshUserList:
ThunkCommandFactory<void, SetUserListLoadingAction | RefreshUserListAction> = () => (dispatch, state, client) => {
  const tenantId = state().tenantData.currentTenantId;
  dispatch(actions.setIsUserListLoading(true));
  return client.get<User[]>(`/${tenantId}/user/`).then((userList) => {
    if (!userList) {
      return;
    }
    dispatch(actions.refreshUserList(userList));
    dispatch(actions.setIsUserListLoading(false));
  });
};
